import type { BduiTranslations } from '../interfaces/bdui';

export const bduiTranslations: BduiTranslations = {
  placeholder_select: 'Select an option',
  placeholder_multiselect: 'Select one or more options',
  placeholder_tag_list: 'Type and press Enter to add',
  help_tag_list: 'Press Enter or comma to add. Click X to remove.',
  placeholder_kv_key: 'Key',
  placeholder_kv_value: 'Value',
  action_kv_add: 'Add row',
  action_kv_remove: 'Remove row',
  action_repeater_add: 'Add item',
  action_repeater_remove: 'Remove item',
  repeater_empty: 'No items yet.',
  repeater_item_title: 'Item {{index}}',

  validation_required: 'This field is required.',
  validation_min_length: 'Must be at least {{length}} characters.',
  validation_max_length: 'Must be at most {{length}} characters.',
  validation_min: 'Must be at least {{value}}.',
  validation_max: 'Must be at most {{value}}.',
  validation_invalid_option: 'Pick one of the available options.',

  sections_nav_label: 'Sections',
  placeholder_search: 'Search…',

  json_help:
    'Edit the raw configuration. Useful for bulk updates or when an AI assistant generates the JSON for you. Save uses the same diff logic as the form.',
  json_parse_error: 'Invalid JSON: {{message}}',
  json_position: 'line {{line}}, column {{col}}',
  json_copy: 'Copy',
  json_copied: 'Copied to clipboard.',
  json_format: 'Format',
  json_validation_title: 'Schema validation',
  json_validation_empty: 'No schema issues.',
  json_copy_error: 'Could not copy to clipboard.',
};
